import { Component } from '@angular/core';

@Component({
  selector: 'about-component',
  templateUrl: './about.component.html',
//   styleUrls: ['./home.component.css']
})
export class AboutComponent {
//   title = 'home';
}